// src/components/Hero.js
import React from "react";
import "./Hero.css";
import VideoBox from "../VideoBox/VideoBox";
import CompanyLogos from "../CompanyLogos/CompanyLogos";
import BrokenBranding from "../BrokenBranding/BrokenBranding";
import BrandlyChange from "../BrandlyChange/BrandlyChange";
import HowWeDoIt from "../HowWeDoIt/HowWeDoIt";
import FeaturesCarousel from "../FeaturesCarousel/FeaturesCarousel";
import LeftGraph from "../../assets/LandingPageGraphics/LeftGraph.png";
import Post from "../../assets/LandingPageGraphics/Post.png";
import Care from "../../assets/LandingPageGraphics/Care.png";
import Celebrate from "../../assets/LandingPageGraphics/Celebrate.png";
import Like from "../../assets/LandingPageGraphics/like.png";
import Love from "../../assets/LandingPageGraphics/love.png";
import RightGraph from "../../assets/LandingPageGraphics/RightGraph.png";
import { useNavigate } from "react-router-dom";


function Hero() {
  const navigate = useNavigate();
  return (
    <section className="hero">
      <div className="left-graphics">
        <div className="post-wrapper-top">
          <img src={Post} alt="Post" className="post-icon-left" />
          <img src={Care} alt="Care" className="care-icon" />
        </div>
        <img src={LeftGraph} alt="LeftGraph" />
        <div className="post-wrapper-bottom">
          <img src={Post} alt="Post" className="post-icon-left" />
          <img src={Celebrate} alt="Celebrate" className="celebrate-icon" />
        </div>
      </div>

      <div className="right-graphics">
  <div className="post-wrapper-top">
    <img src={Like} alt="Like" className="like-icon" />
    <img src={Post} alt="Post" className="post-icon-right flipped" />
    
  </div>
  <img src={RightGraph} alt="RightGraph" />
  <div className="post-wrapper-bottom">
    <img src={Love} alt="Love" className="love-icon" />
    <img src={Post} alt="Post" className="post-icon-right flipped" />
    
  </div>
</div>

      <h1 className="hero-heading">
        <span className="linkedin-text">LinkedIn</span> Personal Branding<br />
        in 3 Steps !
      </h1>

      <button className="cta-button-landing" onClick={()=>{navigate("/login");}}>
        <span className="arrow">→</span> Start For Free
      </button>

      <p className="subtext">*NO CREDIT CARD REQUIRED</p>

      <VideoBox />
      <CompanyLogos />
      <BrokenBranding />
      <BrandlyChange />
      <HowWeDoIt />
      <FeaturesCarousel />

    </section>


  );
}

export default Hero;
